import { Component, OnInit } from '@angular/core';
import Interpreter from 'js-interpreter';

declare let Blockly;

@Component({
  selector: 'app-blockly-editor',
  templateUrl: './blockly-editor.component.html',
  styleUrls: ['./blockly-editor.component.scss']
})
export class BlocklyEditorComponent implements OnInit {

  workspace: any;
  blocklyXMLToolbox: any;
  constructor() { }

  ngOnInit() {

    this.blocklyXMLToolbox = '<xml style="display: none;">' +
        '<category name="Core Logic Builder" colour="210">\n' +
        '        <category name="Logic" >\n' +
        '            <block type="controls_if"></block>\n' +
        '            <block type="logic_compare"></block>\n' +
        '            <block type="logic_operation"></block>\n' +
        '            <block type="logic_negate"></block>\n' +
        '            <block type="logic_boolean"></block>\n' +
        '            <block type="logic_null"></block>\n' +
        '            <block type="logic_ternary"></block>\n' +
        '            <block type="text"></block>\n' +
        '            <block type="text_print">\n' +
        '                <value name="TEXT">\n' +
        '                    <shadow type="text">\n' +
        '                        <field name="TEXT">abc</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '        </category>\n' +
        '</category>' +
        '</xml>';
    this.workspace = Blockly.inject('blocklyDiv', {toolbox: this.blocklyXMLToolbox});
  }


  run() {
    const code = Blockly.JavaScript.workspaceToCode(this.workspace);
    // console.log(code);
    const myInterpreter = new Interpreter(code);
    myInterpreter.run();
    // console.log(myInterpreter.value);

  }

  initApi(interpreter, globalObject) {
    // Add an API function for the alert() block.
    let wrapper = function(text) {
      return alert(arguments.length ? text : '');
    };
    interpreter.setProperty(globalObject, 'alert',
        interpreter.createNativeFunction(wrapper));

    // Add an API function for the prompt() block.
    wrapper = function(text) {
      return prompt(text);
    };
    interpreter.setProperty(globalObject, 'prompt',
        interpreter.createNativeFunction(wrapper));
  }

}
